module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--6-0cc35ae88a52903637ad96c02b687167.jpg";